<div class="loader-container">
	<div class="loader white" [ngClass]="extraClass"></div>
</div>
